import React from 'react'
import PropTypes from 'prop-types'
import { Button, Glyphicon } from 'react-bootstrap'

import './scrollButton.scss'

class ScrollButtonComponent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            scrollButtonClass: '',
        }
    }

    onScroll = () => {
        let indent = document.getElementById(this.props.elementId).offsetTop - document.getElementById('header').offsetHeight
        let scrollButtonClass = window.scrollY > indent ? 'show' : ''

        this.setState({
            scrollButtonClass,
        })
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    render() {
        return <Button
            className={`scroll-button dark ${this.state.scrollButtonClass}`}
            onClick={() => window.scrollTo(0, 0)}
        >
            <Glyphicon glyph="chevron-up" />
        </Button>
    }
}

ScrollButtonComponent.propTypes = {
    elementId: PropTypes.string.isRequired,
}

export default ScrollButtonComponent



// WEBPACK FOOTER //
// ./src/components/core/ScrollButtonComponent/ScrollButtonComponent.js